// Connect Sass
require("../scss/index.scss");

// SVG Sprites
function requireAll(r) {
  r.keys().forEach(r);
}
requireAll(require.context("../images/sprites", true, /\.svg$/));

// Loading
window.addEventListener("load", () => {
  const loading = document.querySelector(".loading");
  if (!loading) return;
  loading.addEventListener("transitionend", e => {
    document.body.removeChild(e.currentTarget);
  });
  document.body.classList.remove("before-load");
});

// jQuery
window.jQuery = window.$ = require("jquery");

// UI Scripts
var UIScripts = (function () {
  // sidebar Fixed - ScrollLeft
  function fixedElements() {
    if ($(".sidebar").length) {
      var fixedScrollLeft = $(".sidebar, .header");
      fixedScrollLeft.css("left", $(document).scrollLeft() * -1);
    }
  }

  // DOMContentLoaded
  window.addEventListener("DOMContentLoaded", function () {});

  // Scroll
  window.addEventListener("scroll", function () {
    fixedElements();
  });
})();

//TOAST Grid
window.Grid = require("tui-grid");
require("tui-grid/dist/tui-grid.min.css");
window.gridStyle = {
  row: {
    hover: {
      background: "#F9FAFC",
    },
  },
  cell: {
    normal: {
      background: "#fff",
      border: "#F0F2F6",
      showVerticalBorder: false,
      text: "#181C22",
    },
    header: {
      background: "#F9FAFC",
      showVerticalBorder: false,
      showHorizontalBorder: true,
      text: "#181C22",
    },
    selectedHeader: {
      background: "#F9FAFC",
      border: "#F9FAFC",
    },
    focused: {
      border: "transparent",
    },
    focusedInactive: {
      border: "transparent",
    },
  },
  selection: {
    background: "transparent",
    border: "transparent",
  },
  area: {
    header: {
      border: "#D4D9E3",
    },
  },
  outline: {
    border: "#D4D9E3",
  },
  scrollbar: {
    border: "transparent",
    background: "transparent",
    thumb: "#D4D9E3",
    emptySpace: "#F9FAFC",
    active: "#D4D9E3",
  },
};